import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { DialogRef } from "@progress/kendo-angular-dialog";
import { WorkActivityOptionsModel } from "app/management/workActivityOptions/work-activity-option.model";
import { WorkActivityOptionsService } from "app/management/workActivityOptions/work-activity-options.service";
import { CedNotificationService } from "ced-ng-library";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { WorkActivityService } from "../workActivity-service";
import { WorkActivityModel } from "../workActivity.model";

@Component({
    selector: 'app-actionType-detail',
    templateUrl: './actionType-details.component.html'
})

export class ActionTypeDetailComponent implements OnInit, OnDestroy {

    private _subject$: Subject<boolean> = new Subject();
    private selectedWorkActivity: WorkActivityModel = null;
    private workActivity: WorkActivityModel = null;
    public workActivityForm: FormGroup;
    public yesNoValues: any[] = [];
    public isSupplierTask : boolean = false;
    public isClientTask : boolean = false;
    public selectedActivityOptions : WorkActivityOptionsModel[];
    public activityOptions: any[] = [];
    constructor(
        private dialog: DialogRef,
        public translateService: TranslateService,
        private workActivityService: WorkActivityService,
        private cedNotificationService: CedNotificationService,
        private workActivityOptionsService: WorkActivityOptionsService,
        private cd: ChangeDetectorRef) {

        this.yesNoValues.push({ id: true, value: this.translateService.instant("YES") });
        this.yesNoValues.push({ id: false, value: this.translateService.instant("NO") });
    }


    ngOnInit() {
        this.initForm();
        this.getActivityOptions();
        if (this.selectedWorkActivity != null){
            this.populateControls();
            this.getById();
        }
    }

    getById(){
        this.workActivityService
        .getOneById(this.selectedWorkActivity.waId)
        .pipe(takeUntil(this._subject$))
        .subscribe((result) => {
            this.workActivity = result;
           this.selectedActivityOptions = this.workActivity.waActivityOptions;
            this.cd.detectChanges();
        });
    }

    private initForm() {
        this.workActivityForm = new FormGroup({
            waCode: new FormControl("", Validators.required),
            waLongName: new FormControl("", Validators.required),
            waInactive: new FormControl(""),
            waIsSupplierTask: new FormControl("", Validators.required),
            waIsClaimReserve: new FormControl(""),
            waIsPurchaseOrder: new FormControl(""),
            waIsClientTask: new FormControl("", Validators.required),
            waIsInvoiceable: new FormControl(""),
            waActivityOptions: new FormControl(null),
        });
    }

    populateControls() {
        this.workActivityForm.patchValue(this.selectedWorkActivity);
        this.workActivityForm.controls.waInactive.patchValue(!this.selectedWorkActivity.waInactive);
        if(this.selectedWorkActivity.waIsClientTask == true)
        {
            this.isClientTask = true;
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
            this.workActivityForm.controls.waActivityOptions.setValidators([Validators.required]);
            this.workActivityForm.controls.waActivityOptions.updateValueAndValidity();
        }
        else if (this.selectedWorkActivity.waIsSupplierTask == true)
        {
            this.isSupplierTask = true;
            this.workActivityForm.controls.waIsClaimReserve.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsClaimReserve.updateValueAndValidity();
            this.workActivityForm.controls.waIsPurchaseOrder.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsPurchaseOrder.updateValueAndValidity();
            this.workActivityForm.controls.waInactive.setValidators([Validators.required]);
            this.workActivityForm.controls.waInactive.updateValueAndValidity();
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
        }
    }

    getSelectedWorkActivity() {
        let workActivity = new WorkActivityModel();
        workActivity.waId = this.selectedWorkActivity != null ? this.selectedWorkActivity.waId : null;        
        workActivity.waCode = this.workActivityForm.controls.waCode.value;
        workActivity.waLongName = this.workActivityForm.controls.waLongName.value;
        workActivity.waInactive = !this.workActivityForm.controls.waInactive.value;
        workActivity.waIsSupplierTask = this.workActivityForm.controls.waIsSupplierTask.value;
        workActivity.waIsClaimReserve = this.workActivityForm.controls.waIsClaimReserve.value;
        workActivity.waIsPurchaseOrder = this.workActivityForm.controls.waIsPurchaseOrder.value;
        workActivity.waIsClientTask = this.workActivityForm.controls.waIsClientTask.value;
        workActivity.waIsInvoiceable = this.workActivityForm.controls.waIsInvoiceable.value;
        workActivity.waActivityOptions = this.workActivityForm.controls.waActivityOptions.value;
        return workActivity;
    }

    save() {
        if (this.workActivityForm.valid) {
            let workActivity = this.getSelectedWorkActivity();

            if (workActivity.waId == null) {
                this.workActivityService
                    .save(workActivity)
                    .pipe(takeUntil(this._subject$))
                    .subscribe(() => {
                        this.dialog.close(workActivity);
                    });
            }
            else{
                this.workActivityService
                    .update(workActivity)
                    .pipe(takeUntil(this._subject$))
                    .subscribe(() => {
                        this.dialog.close(this.selectedWorkActivity);
                    });
            }
        }
        else {
            this.cedNotificationService.error("NOTIFICATIONS.REQUIRED_DATA_MISSING")
        }
    }

    changeClientTask(event)
    {
        if(event == true)
        {
            this.workActivityForm.controls.waIsSupplierTask.setValue(this.yesNoValues[1].id);
            this.isSupplierTask = false ;
            this.isClientTask = true ;
            this.workActivityForm.controls.waIsClaimReserve.clearValidators();
            this.workActivityForm.controls.waIsClaimReserve.setValue(null);
            this.workActivityForm.controls.waIsClaimReserve.updateValueAndValidity();
            this.workActivityForm.controls.waIsPurchaseOrder.clearValidators();
            this.workActivityForm.controls.waIsPurchaseOrder.setValue(null);
            this.workActivityForm.controls.waIsPurchaseOrder.updateValueAndValidity();
            this.workActivityForm.controls.waInactive.clearValidators();
            this.workActivityForm.controls.waInactive.updateValueAndValidity();
            this.workActivityForm.controls.waIsInvoiceable.setValue(null);
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
            this.workActivityForm.controls.waActivityOptions.setValue(null);
            this.workActivityForm.controls.waActivityOptions.setValidators([Validators.required]);
            this.workActivityForm.controls.waActivityOptions.updateValueAndValidity();
        }
        else if(event == false)
        {
            this.workActivityForm.controls.waIsSupplierTask.setValue(this.yesNoValues[0].id);
            this.isSupplierTask = true ;
            this.isClientTask = false ;
            this.workActivityForm.controls.waIsClaimReserve.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsClaimReserve.updateValueAndValidity();
            this.workActivityForm.controls.waIsPurchaseOrder.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsPurchaseOrder.updateValueAndValidity();
            this.workActivityForm.controls.waInactive.setValidators([Validators.required]);
            this.workActivityForm.controls.waInactive.updateValueAndValidity();
            this.workActivityForm.controls.waIsInvoiceable.setValue(null);
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
            this.workActivityForm.controls.waActivityOptions.clearValidators();
            this.workActivityForm.controls.waActivityOptions.setValue(null);
            this.workActivityForm.controls.waActivityOptions.updateValueAndValidity();
        }
    }

    changeSupplierTask(event)
    {
        if(event == true)
        {
            this.workActivityForm.controls.waIsClientTask.setValue(this.yesNoValues[1].id);
            this.isSupplierTask = true ;
            this.isClientTask = false ;
            this.workActivityForm.controls.waIsClaimReserve.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsClaimReserve.updateValueAndValidity();
            this.workActivityForm.controls.waIsPurchaseOrder.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsPurchaseOrder.updateValueAndValidity();
            this.workActivityForm.controls.waInactive.setValidators([Validators.required]);
            this.workActivityForm.controls.waInactive.updateValueAndValidity();
            this.workActivityForm.controls.waIsInvoiceable.setValue(null);
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
            this.workActivityForm.controls.waActivityOptions.clearValidators();
            this.workActivityForm.controls.waActivityOptions.setValue(null);
            this.workActivityForm.controls.waActivityOptions.updateValueAndValidity();
        }
        else if(event == false)
        {
            this.workActivityForm.controls.waIsClientTask.setValue(this.yesNoValues[0].id);
            this.isSupplierTask = false ;
            this.isClientTask = true ;
            this.workActivityForm.controls.waIsClaimReserve.clearValidators();
            this.workActivityForm.controls.waIsClaimReserve.setValue(null);
            this.workActivityForm.controls.waIsClaimReserve.updateValueAndValidity();
            this.workActivityForm.controls.waIsPurchaseOrder.clearValidators();
            this.workActivityForm.controls.waIsPurchaseOrder.setValue(null);
            this.workActivityForm.controls.waIsPurchaseOrder.updateValueAndValidity();
            this.workActivityForm.controls.waInactive.clearValidators();
            this.workActivityForm.controls.waInactive.updateValueAndValidity();
            this.workActivityForm.controls.waIsInvoiceable.setValue(null);
            this.workActivityForm.controls.waIsInvoiceable.setValidators([Validators.required]);
            this.workActivityForm.controls.waIsInvoiceable.updateValueAndValidity();
            this.workActivityForm.controls.waActivityOptions.setValue(null);
            this.workActivityForm.controls.waActivityOptions.setValidators([Validators.required]);
            this.workActivityForm.controls.waActivityOptions.updateValueAndValidity();
            
        }
    }

    cancel() {
        this.dialog.close(null);
    }
 
    getActivityOptions(){
        this.workActivityOptionsService.getAll()
        .pipe(takeUntil(this._subject$))
        .subscribe((data: any) => {
          this.activityOptions = data.sort((a, b) => a.aoShortName.toLowerCase() > b.aoShortName.toLowerCase() ? 1 : -1);
        });
    }

    ngOnDestroy(): void {
        this._subject$.next();
        this._subject$.complete();
    }
}